import {useEffect, useState} from "react";
import {LineChart, sampleLineOptions} from "./components/LineChart";


function mapEstimates (data) {
    let estimateData = {};
    let labels=[];
    let yearOne=[];
    let yearTwo=[];
    let yearThree=[];
    let yearFour=[];
    var columns=0;

    if (data !== null) { 

        data.stock_annual_estimates.forEach( (item, idx) => {
            /*
            if ((idx % 3) === 1){
            labels.push(idx)
            }
            */
            if (idx > 0){
                if (labels[idx-1] !== item.obs_date){
                    labels.push(item.obs_date)
                    columns++;
                }
                // otherwise do not increment the columns
            }
            else {
                labels.push(item.obs_date)
                columns++;
            }
             
            
            if (item.per_cal_year === 2025)
            {
                while (yearOne.length < columns)
                {
                    // add some padding
                    if (yearOne.lenght === 0)
                        yearOne.push(+item.eps_mean_est) 
                    else 
                        yearOne.push(+yearOne[yearOne.length-1])
                }
                yearOne.push(+item.eps_mean_est) 
            }
            else if (item.per_cal_year === 2026)
            {
                while (yearTwo.length < columns)
                {
                    // add some padding
                    if (yearTwo.lenght === 0)
                        yearTwo.push(+item.eps_mean_est) 
                    else 
                        yearTwo.push(+yearTwo[yearTwo.length-1])
                }  
                yearTwo.push(+item.eps_mean_est) 
            }
            else if (item.per_cal_year === 2027)
            {
                while (yearThree.length < columns)
                {
                    // add some padding
                    if (yearThree.lenght === 0)
                        yearThree.push(+item.eps_mean_est) 
                    else 
                        yearThree.push(+yearThree[yearThree.length-1])
                } 
                yearThree.push(+item.eps_mean_est)
            }
            else if (item.per_cal_year === 2028)
            {
                while (yearFour.length < columns)
                {
                    // add some padding
                    if (yearFour.lenght === 0)
                        yearFour.push(+item.eps_mean_est) 
                    else 
                        yearFour.push(+yearFour[yearFour.length-1])
                } 
                yearFour.push(+item.eps_mean_est)
            }

        }) 
        estimateData = {labels:labels, one:yearOne, two:yearTwo, three:yearThree, four:yearFour};
    }

    return estimateData;
  }

 
  function mapAnalytics (data) {

    let analyticsArray = []; // this is output array
    // 0 =================================
    if (data.one) { 
        console.log(data);
        let thisYear = {};

        let first = 0.0;
        let last = 0.;
        let min = 0.0;
        let max = 0.0;
        let sum = 0.0;
        let count = 0;
        let avg = 0.0;
        let short_moving_avg = 0.0;
        let long_moving_avg = 0.0;
        let short_count = 0;
        let long_count = 0;

        data.one.forEach( (est, idx) => {
            sum += est;
            last = est;
            if(idx === 0){first = est};
            if(est < min){min = est};
            if(est > max){max = est};
            if(idx > 0){avg = sum/idx}else{avg = sum};

            if(count > 0){avg = sum/count};

            if (count >= 10){
                short_moving_avg = ((last + (short_moving_avg * short_count)) / (short_count +1)); 
                short_count +=1;
            } 
    
            if (count >= 20) {
                long_moving_avg = ((last + (long_moving_avg * long_count)) / (long_count +1));
                long_count +=1;
            }
            count += 1;
        })
        
        thisYear = {first:first, last:last, min:min, max:max, avg:avg, short_moving_avg:short_moving_avg, long_moving_avg:long_moving_avg};
       
        let item = {};
        let percent = -1000; 
        if (max-min > 0){
            percent = (thisYear.last - thisYear.short_moving_avg)/(thisYear.short_moving_avg);
        }
        if(percent>=0.05)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Current short-term sentiment trend is Favorabel";           
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Current short-term sentiment trend is Positive";
        }
        else 
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Current short-term sentiment trend is Negative";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

        item = {};
        percent = -1000; 
        if (max-min > 0){
            percent = (thisYear.last - thisYear.long_moving_avg)/(thisYear.long_moving_avg);
        }
        if(percent>=0.05)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Current long-term sentiment trend is Favorabel";           
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Current long-term sentiment trend is Positive";
        }
        else if(percent<0)
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Current long-term sentiment trend is Negative";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

    }
    if (data.two) { 
        console.log(data);
        let nextYear = {};

        let first = 0.0;
        let last = 0.;
        let min = 0.0;
        let max = 0.0;
        let sum = 0.0;
        let count = 0;
        let avg = 0.0;
        let short_moving_avg = 0.0;
        let long_moving_avg = 0.0;
        let short_count = 0;
        let long_count = 0;

        data.two.forEach( (est, idx) => {
            sum += est;
            last = est;
            if(idx === 0){first = est};
            if(est < min){min = est};
            if(est > max){max = est};
            if(idx > 0){avg = sum/idx}else{avg = sum};

            if(count > 0){avg = sum/count};

            if (count >= 10){
                short_moving_avg = ((last + (short_moving_avg * short_count)) / (short_count +1)); 
                short_count +=1;
            } 
    
            if (count >= 20) {
                long_moving_avg = ((last + (long_moving_avg * long_count)) / (long_count +1));
                long_count +=1;
            }
            count += 1;
        })
        
        nextYear = {first:first, last:last, min:min, max:max, avg:avg, short_moving_avg:short_moving_avg, long_moving_avg:long_moving_avg};
       
        let item = {};
        let percent = -1000; 
        if (max-min > 0){
            percent = (nextYear.last - nextYear.short_moving_avg)/(nextYear.short_moving_avg);
        }
        if(percent>=0.10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Future short-term sentiment trend is Favorabel";           
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Future short-term sentiment trend is Positive";
        }
        else 
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Future short-term sentiment trend is Negative";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

        item = {};
        percent = -1000; 
        if (max-min > 0){
            percent = (nextYear.last - nextYear.long_moving_avg)/(nextYear.long_moving_avg);
        }
        if(percent>=0.10)
        {
            item.Percent=percent;
            item.Favourable=2;
            item.Description="Future long-term sentiment trend is Favorabel";           
        }
        else if(percent>=0)
        {
            item.Percent=percent;
            item.Favourable=1;
            item.Description="Future (long-term) sentiment trend is Positive";
        }
        else 
        {
            item.Percent=percent;
            item.Favourable=0;
            item.Description="Future (long-term) sentiment trend is Negative";
        }
        if(percent!==-1000){analyticsArray = [...analyticsArray, item];}

    }
    return (analyticsArray);
}

function setEstimatesChart (estiamtes) {
    let eData = {};
    if (estiamtes ) {
      eData = {
        labels: estiamtes.labels,//[200,190,180,170,160,150,140,130,120,110,100,90,80,70,60,50,40,30,20,10,0],
        datasets: [
        {
           label: '2025',
           data: estiamtes.one,
           borderColor: 'rgba(53, 162, 235, 0.8)', // Blue
           backgroundColor: 'rgba(53, 162, 235, 0.8)',
           pointRadius: 0,
        },
        {
            label: '2026',
            data: estiamtes.two,
            borderColor: 'rgba(53, 235, 162, 0.8)', //Green
            backgroundColor: 'rgba(53, 235, 162, 0.8)',
            pointRadius: 0,

        },
        {
            label: '2027',
            data: estiamtes.three,
            borderColor: 'rgba(255, 235, 99, 0.8)', // Yello
            backgroundColor: 'rgba(255, 235, 99, 0.8)',
            pointRadius: 0,
        }
        ,
        {
            label: '2028',
            data: estiamtes.four,
            borderColor: 'rgba(153, 102, 235, 0.8)', // Purple
            backgroundColor: 'rgba(153, 102, 235, 0.8)',
            pointRadius: 0,
        }]
      }; 
    }
    return eData;
  };

function Estimates (props) {

    const [estimates, setEstimates] = useState(null);
    const [analytics, setAnalytics] = useState([]);

    const ticker = props.ticker;

    function fetchEstimates(url)  {
    
        const abortCtrl   = new AbortController();
    
        const fetchData= async () => {
              console.log("fetch estimates... "); 
              try {
                  const response = await fetch(url,{signal: abortCtrl.signal});
                  const json = await response.json();
                  const estimatesArray = mapEstimates(json)
                  setEstimates(estimatesArray);
                  setAnalytics(mapAnalytics(estimatesArray));
                  console.log(analytics);
                  console.log("fetch estimates done");  
   
              } catch (error) {
                  if (error.name === 'AbortError'){
                      console.log("aborted", error);
                  }
                  else {
                      console.log("error", error);
                  }
              }

        };
      
        fetchData();
      
        return () => abortCtrl.abort();
      }

      useEffect(() => {
        const server = "https://app.cuetraders.com";
    
        const url = server+"/api/get_annual_estimates.php?ticker="+ticker ;
        fetchEstimates(url);

      }, [ticker]);

      return (  <div className="Esitimates">{estimates &&
        <div className="col-lg-12 col-sm-12 col-xs-12" align="left">
        <h4> Earnings Estimates </h4>
        <div >
        <LineChart chartData={setEstimatesChart(estimates)} chartOptions={sampleLineOptions}></LineChart>
        </div>
        { analytics[0] && <div>
          <ul className="list-style-type:disc">
            <li> {(analytics[0].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[0].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[0].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[0].Description}</i></li>
            <li> {(analytics[1].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[1].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[1].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[1].Description}</i></li>
            <li> {(analytics[2].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[2].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[2].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[2].Description}</i></li>
            <li> {(analytics[3].Favourable === 2)&& <i className="fa fa-check"></i> } {(analytics[3].Favourable === 1)&& <i className="fa fa-question"></i> } {(analytics[3].Favourable === 0)&& <i className="fa fa-close"></i> }<i>{analytics[3].Description}</i></li>
             </ul>
          </div>}
         </div>  }   
      </div>);
    } 
    export default Estimates;